import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzModalModule } from 'ng-zorro-antd/modal';

import { AccessLimitationDialogComponent } from './access-limitation-dialog.component';

@NgModule({
  declarations: [AccessLimitationDialogComponent],
  exports: [AccessLimitationDialogComponent],
  imports: [
    CommonModule,
    NzButtonModule,
    NzTableModule,
    NzModalModule,
  ]
})
export class AccessLimitationDialogModule { }
